import styled from 'styled-components';
import _Tooltip from 'components/Tooltip';
import { sizes } from 'style';

export const Tooltip = styled(_Tooltip)`
  transition: opacity 200ms;

  > div {
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.black};
  }
`;

export const TooltipLabel = styled.p`
  margin: 0;
  transition: opacity 200ms;
  cursor: default;
  opacity: 0.7;
`;

export const TooltipWrapper = styled.div`
  display: none;
  align-items: center;
  position: absolute;
  bottom: -20px;
  left: 0px;

  :hover {
    > ${TooltipLabel} {
      opacity: 1;
    }

    > ${Tooltip} {
      opacity: 1;

      > div {
        opacity: 1;
        visibility: visible;
        transition: opacity 0.25s;
        width: 330px;
        border-radius: 10px;
        padding: 16px;
        line-height: 22px;
        left: 32px;
        transform: translateY(-45%);
      }
    }
  }

  @media ${sizes.tabletPortrait} {
    display: flex;
  }
`;
